import { useEffect, useState } from 'react';
import { ApiEndpoints } from 'services/endpoints';
import { apiService } from 'services/service';

export const useGetBanks = () => {
    const [banks, setBanks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchBanks = async () => {
        setIsLoading(true);
        try {
            const response = await apiService.get(ApiEndpoints.GET_BANKS);
            setBanks(response?.data?.data || []);
            return response?.data?.data;
        } catch (error) {
            console.log('Error from banks', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchBanks();
    }, []);

    return { banks, fetchBanks, isLoading };
};
